import { root } from '../../../../../store/constants';
import { Dispatch, ThunkAction } from '../../../../../types/actions';

export const closeTemplates = (): ThunkAction => {
    return (dispatch: Dispatch) => {
        root.App.router.navigate(root.App.router.getUrl(null), {trigger: true});
    };
};
